module.exports = __webpack_public_path__ + "static/media/admin-more-vertical-rec.f911cc17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin-more-vertical-rec.svg
// module id = 390
// module chunks = 1